import InstagramFeed from './instagram-feed';

export default class InstagramFeedDesktop extends InstagramFeed {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/instagram-feed/instagram-feed.desktop.js